import { EntityList } from '../../../common/entityFramework/entityList/EntityList'
import { ExprUtils } from '../../../common/utils/ExprUtils';
import { useCallback } from 'react';

export const Ndc11ProdList = ({ ndc9ProdId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!ndc9ProdId) return;
    const expr = rowsReq.expr;
    rowsReq.expr = ExprUtils.and(expr, ExprUtils.whereParams('ndc9ProdId', ndc9ProdId))
  }, [ndc9ProdId]);

  return <EntityList entity="NDC11_PROD" augRowsReq={augRowsReq} />
}
